import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Row, Cell, List } from '../../../components/List';
import { VehicleAvatar } from '../../../components/VehicleAvatar';
import { KanbanProgressBar } from '../../KanbanBoards/components/ProgressBar';
import { VehicleStatusCard } from './CardStatus';
import { VehicleAddToOrderCard } from './VehicleAddToOrderCard';
import { VehicleOutgoingBPMInvoiceCard } from './VehicleOutgoingBPMInvoiceCard';
import { getDate, getDaysInStock } from '../helpers';
import { selectUserId, selectWork } from '../../Api/selectors';
import { selectUser } from '../../Users/selectors';
import { fetchUser } from '../../Users/actions';
import { getPropByName, getPropertyValueObjectByName } from '../../../utils/props';
import { REQUEST_USER } from '../../Users/constants';
import { Loader } from '../../../components/Loader';
import { fetchVehicle } from '../actions';
import { VehicleAvatarSlider } from '../../../components/VehicleAvatarSlider';
import { VehicleGetProductInvoicesCard } from './VehicleGetProductInvoices';
import { ASSIGN_WORKFLOW_TO_VEHICLE, REQUEST_VEHICLE } from '../constants';
import { Button } from '../../../components/Buttons';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import { formatLicensePlate } from '../../../utils/string';
import cn from 'classnames';
import styles from './CardInfo.module.css';
import { WS2_1_Interior } from '../../KanbanBoards/cells/WS/WS2_1_Interior';
import { selectActions } from '../../Actions/selectors';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { RegplateLabel } from './RegplateLabel';
import { ProgressBarAdvertisement } from './ProgressBarAdvertisement';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import { WithWorkflow } from '../../Workflows/components/WithWorkflow';
import LoadingField from '../../../containers/App/Components/LoadingField/LoadingField';
import { REQUEST_WORKFLOW } from '../../Workflows/constants';

dayjs.extend(customParseFormat);

const Container = styled.div`
  font-size: 14px;
  h3 {
    font-size: 20px;
  }
  .type {
    color: #6c757d;
  }
  .regplate {
  }

  .secondary-info {
  }
  .secondary-info-list {
    font-weight: 400;
  }
  .alt-block {
    position: absolute;
    left: 0;
    margin-top: -100px;

    z-index: 2;
    min-width: ${props => (props.innerWidth < 768 ? '150px' : '250px')};
    max-width: ${props => (props.innerWidth < 768 ? '150px' : '300px')};
    padding: 10px 8px;
    background-color: #cccccc;
    color: #6d727b;
    white-space: normal;
    text-align: left;
    border-radius: 5px;
  }
  .alt-block-margin {
    padding-left: 15px;
    padding-bottom: 5px;
  }
`;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class VehicleInfoCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.vehicle?.user_changed_status) {
      this.props.fetch(this.props.vehicle?.user_changed_status, result => this.setState({ user: result }));
    }
  }

  isHovered(hoveredOption, vehicleId) {
    this.setState({ isHover: hoveredOption, hoveredId: vehicleId });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.vehicle?.user_changed_status !== this.props.vehicle?.user_changed_status) {
      this.props.fetch(this.props.vehicle?.user_changed_status, result => this.setState({ user: result }));
    }
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get statusUpdatedAt() {
    const dateString = getPropertyValueObjectByName(this.props.vehicle, 'status')?.updatedAt;

    // Check if dateString is valid and parse it as a Date object
    if (!dateString) {
      console.error('Invalid date:', dateString);
      return 'Invalid Date'; // or some fallback value
    }

    const parsedDate = new Date(dateString);
    if (isNaN(parsedDate.getTime())) {
      // Handle invalid date format case
      console.error('Invalid date:', dateString);
      return 'Invalid Date'; // or some fallback value
    }

    // Return the updated date in the desired format (local time will automatically account for DST)
    return parsedDate.toLocaleString(); // This handles local time and DST automatically
  }

  get userChangedStatus() {
    let name = this.state.user ? getPropByName(this.state.user, 'name') : this.props.changedStatusUser?.name || '';

    let surname = this.state.user ? getPropByName(this.state.user, 'surname') : this.props.changedStatusUser?.surname || '';
    return `${name} ${surname}`;
  }

  get statusRemark() {
    if (!this.props.vehicle?.status_remark) return '';

    return `${this.props.vehicle?.status_remark}`;
  }

  getActionIdByName(name) {
    return this.props?.actions?.find(a => a.functionName === name)?.id ?? null;
  }

  renderAddToOrderButton() {
    if (window.innerWidth <= 768 && env.clientId === AppClientId.HOOIKAMMER) return null;
    if (env.clientId === AppClientId.HILTERMANN) return null;
    return <VehicleAddToOrderCard vehicle={this.props.vehicle} />;
  }

  renderProductInvoiceOverviewButton() {
    if (env.clientId == AppClientId.AUTOWIENTJES || env.clientId == AppClientId.HILTERMANN) return null;
    return (
      <div className={styles.containerButton}>
        <Button
          className={styles.buttonOpenModal}
          primary
          onClick={() => this.to(`/vehicles/${this.props.vehicle?.id}/invoice`)}
        >
          {this.lbl('vehicle.details.productInvoicesOverview')}
        </Button>
      </div>
    );
  }

  renderActionModal() {
    if (!this.props.webLogin) {
      return (
        <div className="mb-2">
          {/* <WS2_1_Interior
            vehicleDetails
            cell={{ vehicle: this.props.vehicle }}
            action={{ label: 'label', id: this.getActionIdByName('WS2_1_Interior') }}
            payload={{ task_name: 'task_spray' }}
            column={{ label: 'WS2_1_Interior' }}
          /> */}
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    const vehicle = this.props.vehicle;
    const HOOI_inslag_done_date = vehicle.HOOI_inslag_done_date
      ? new Date(vehicle.HOOI_inslag_done_date)
      : new Date().toISOString();
    const HOOI_uitslag_done_date = vehicle.HOOI_uitslag_done_date
      ? new Date(vehicle.HOOI_uitslag_done_date)
      : new Date().toISOString();
    const days = Math.floor((new Date(HOOI_uitslag_done_date) - new Date(HOOI_inslag_done_date) + 86400000) / 86400000);

    let nonNullCount = 0; // Initialize to a number
    let requiredFields = [];

    if (vehicle.vehicle_purpose === 'commercial') {
      if (vehicle.fuel_type === 'electric' || vehicle.fuel_type === 'elektrisch') {
        requiredFields = [
          ...env.requiredFieldsCommercial.map(field => field.toLowerCase()),
          ...env.requiredFieldsElectric.map(field => field.toLowerCase()),
        ];
      } else {
        requiredFields = env.requiredFieldsCommercial.map(field => field.toLowerCase());
      }

      nonNullCount = requiredFields.filter(field => {
        return vehicle[field] !== null && vehicle[field] !== undefined;
      }).length;
    }

    if (vehicle.vehicle_purpose === 'passenger') {
      if (vehicle.fuel_type === 'electric' || vehicle.fuel_type === 'elektrisch') {
        requiredFields = [
          ...env.requiredFieldsPersonal.map(field => field.toLowerCase()),
          ...env.requiredFieldsElectric.map(field => field.toLowerCase()),
        ];
      } else {
        requiredFields = env.requiredFieldsPersonal.map(field => field.toLowerCase());
      }

      nonNullCount = requiredFields.filter(field => {
        return vehicle[field] !== null && vehicle[field] !== undefined;
      }).length;
    }

    console.log(vehicle.workflow_id);

    // Calculate the completeness percentage
    const completenessPercentage = requiredFields.length > 0 ? nonNullCount / requiredFields.length : 0;

    console.log(completenessPercentage + ' percentage');

    const steps = [
      { threshold: 1, description: 'Uitstekend', color: '#00BFAE' },
      { threshold: 0.9, description: 'Zeer goed', color: '#24B99B' },
      { threshold: 0.825, description: 'Goed', color: '#48B388' },
      { threshold: 0.6, description: 'Redelijk', color: '#6CAD75' },
      { threshold: 0.375, description: 'Matig', color: '#90A862' },
      { threshold: 0.25, description: 'Onvoldoende', color: '#B4A24F' },
      { threshold: 0.125, description: 'Slecht', color: '#D89C3C' },
      { threshold: 0, description: 'Zeer slecht', color: '#FC9629' },
    ];

    // Zoek de juiste categorie gebaseerd op completenessPercentage
    const category = steps.find(step => completenessPercentage >= step.threshold);

    // Zoek de juiste categorie gebaseerd op completenessPercentage

    const cellStyle = {
      color: category ? category.color : '#FC9629', // Fallback naar 'zeer slecht' als geen categorie gevonden
    };
    return (
      <Card className={cn('vehicle-info-card info-card info', styles.card)}>
        <Container width={window.innerWidth}>
          <div className={styles.titleContainer}>
            <h3 className={styles.brandName}>
              {vehicle.brand_name}&nbsp;{vehicle.model_name}
            </h3>
            <h3 className={styles.modelInfo}>
              {vehicle?.model_info}&nbsp;{vehicle?.type}&nbsp;{vehicle?.articlecode}
            </h3>
            <h3 className={styles.modelInfo}>
              <RegplateLabel regplate={vehicle?.regplate} />
            </h3>
          </div>
          <div className={styles.infoBox}>
            <span className={styles.infoVehicle}>{formatLicensePlate(vehicle?.regplate)}</span>
            <span className={styles.infoVehicle}>{parseInt(vehicle?.mileage || '0').toLocaleString() + ' km'}</span>
            <span className={styles.infoVehicle}>{getDate(vehicle?.date_first_allowance)}</span>
          </div>

          <VehicleStatusCard
            style={{ minWidth: '100%' }}
            setStatusLogs={'true'}
            loggedInUserId={this.props.loggedInUserId}
            vehicle={vehicle}
          />
          <div className={styles.containerInfo}>
            {env.clientId !== AppClientId.HOOIKAMMER ? (
              <div className={styles.avatarContainer}>
                <VehicleAvatar className={styles.avatar} vehicle={vehicle} location1={'infoCard'} />
              </div>
            ) : (
              <div className={styles.sliderContainer}>
                <VehicleAvatar className={styles.avatar} vehicle={vehicle} location1={'infoCard'} />
              </div>
            )}
          </div>

          {vehicle.active_claim == '1' || vehicle.active_claim == '2' ? (
            <div style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '5px' }}>
              <img
                style={{ cursor: 'pointer' }}
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/OOjs_UI_icon_alert-warning.svg/1024px-OOjs_UI_icon_alert-warning.svg.png"
                width="18"
              />
              <span style={{ marginLeft: '5px' }}>Claim op dit voertuig!</span>
            </div>
          ) : (
            <img
              style={{ cursor: 'pointer', opacity: '0.1', marginLeft: '5px' }}
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/OOjs_UI_icon_alert-warning.svg/1024px-OOjs_UI_icon_alert-warning.svg.png"
              width="18"
            />
          )}

          {(env.clientId == AppClientId.HOOIKAMMER || env.clientId == AppClientId.HILTERMANN) && (
            <>
              <div className={styles.containerLabel}>
                <div className={styles.formField}>
                  <div className={styles.textContainer}>{this.lbl('vehicle.property.bedrijfsvoorraad')}</div>

                  <div className={styles.labelTabel}>
                    {env.clientId === AppClientId.HOOIKAMMER ? (
                      vehicle?.orb_stock_status == '1' ? (
                        <div style={{ color: '#D9534F', fontWeight: 'bold' }}>{this.lbl('vehicle.details.yes')}</div>
                      ) : (
                        <div style={{ color: '#1C9789', fontWeight: 'bold' }}>{this.lbl('vehicle.details.no')}</div>
                      )
                    ) : env.clientId === AppClientId.HILTERMANN &&
                      vehicle?.task_HILT_purchase_release_tdn_insurance == '0' ? (
                      <div style={{ color: '#D9534F', fontWeight: 'bold' }}>{this.lbl('vehicle.details.yes')}</div>
                    ) : (
                      <div style={{ color: '#1C9789', fontWeight: 'bold' }}>{this.lbl('vehicle.details.no')}</div>
                    )}
                  </div>
                </div>
              </div>



              <div className={styles.containerLabel}>
                <div className={styles.formField}>
                  <div className={styles.textContainer}>{this.lbl('vehicle.property.workflowId')}</div>

                  {this.props.workAssignWorkflow ? (
                    <LoadingField />
                  ) : (
                    <div className={styles.labelTabel}>
                      {vehicle?.workflow_id && (
                        <WithWorkflow label workflow_id={vehicle?.workflow_id} propertyName={'name'} />
                      )}
                    </div>
                  )}
                </div>
              </div>


              <div className={styles.containerLabel}>
                <div className={styles.formField}>
                  <div className={styles.textContainer}>{this.lbl('vehicle.property.category_id')}</div>

                
                    <div className={styles.labelTabel}>
                      {vehicle?.category_id }
                    </div>
                 
                </div>
              </div>


              
            </>
          )}



          <div className={styles.containerLabel}>
            <div key={'last_change'} className={styles.formField}>
              <div className={styles.textContainer}>{this.lbl('vehicle.details.status_log.last_change')}</div>
              <div className={styles.labelTabel}>{this.props.work ? <Loader small /> : this.statusUpdatedAt}</div>
            </div>
          </div>
          {vehicle?.user_changed_status && (
            <div className={styles.containerLabel}>
              <div key={'status_log'} className={styles.formField}>
                <div className={styles.textContainer}>{this.lbl('vehicle.details.status_log.filled_by')}</div>
                <div className={styles.labelTabel}>{this.props.work ? <Loader small /> : this.userChangedStatus}</div>
              </div>
            </div>
          )}
          {this.statusRemark?.trim()?.length >= 1 && (
            <div className={styles.containerLabel}>
              <div key={'status_remark'} className={styles.formField}>
                <div className={styles.textContainer}>{this.lbl('vehicle.details.status_log.remark')}:</div>
                <div className={styles.labelTabel}>{this.statusRemark}</div>
              </div>
            </div>
          )}
          <div className={styles.containerLabel}>
            <div key={'stage_days'} className={styles.formField}>
              <div className={styles.textContainer}>{this.lbl(`vehicle.property.days_is_stock`)}</div>
              <div className={styles.labelTabel}>{getDaysInStock(vehicle)}</div>
            </div>
          </div>
          {vehicle['date_expected'] && (
            <div className={styles.containerLabel}>
              <div key={'add_to_order'} className={styles.formField}>
                <div className={styles.textContainer}>{this.lbl(`vehicle.property.date_expected`)}</div>
                <div className={styles.labelTabel}>{getDate(vehicle['date_expected'])}</div>
              </div>
            </div>
          )}
          {env.clientId == AppClientId.INDEWAL && (
            <>
              {vehicle?.show_inspection_on_sales_website != '1' && vehicle?.show_on_sales_website == '1' && (
                <div className={styles.containerLabel}>
                  <div className={styles.formField}>
                    <div className={styles.textContainer}>{this.lbl(`vehicle.property.aandachtspunten_online`)}</div>
                    <div className={styles.labelTabel}>
                      <div style={{ color: '#D9534F', fontWeight: 'bold' }}>Niet zichtbaar</div>
                    </div>
                  </div>
                </div>
              )}
              {vehicle?.show_inspection_on_sales_website == '1' && vehicle?.show_on_sales_website == '1' && (
                <div className={styles.containerLabel}>
                  <div className={styles.formField}>
                    <div className={styles.textContainer}>{this.lbl(`vehicle.property.aandachtspunten_online`)}</div>
                    <div className={styles.labelTabel}>
                      <div style={{ color: '#1C9789' }}>Zichtbaar</div>
                    </div>
                  </div>
                </div>
              )}

              <div className={styles.containerLabel}>
                <div className={styles.formField}>
                  <div className={styles.textContainer}>{this.lbl(`vehicle.property.advert_quality`)}</div>
                  <div className={styles.labelTabel}>
                    <div style={cellStyle}> {category ? category.description : 'Onbekend'}</div>
                  </div>
                </div>
              </div>
              <div className={styles.containerLabel}>
                <div key={'advert_quality'} className={styles.formField}>
                  <div className={styles.textContainer}>
                    <a
                      onMouseDown={() => this.isHovered('hoveredRemarks', vehicle.id)}
                      onMouseLeave={() => this.isHovered(false)}
                    >
                      <ProgressBarAdvertisement progressAdvertisement={completenessPercentage} height={10} width={'300'} />
                      {this.state.isHover === 'hoveredRemarks' && (
                        <div className="alt-block">
                          <div className="alt-block-margin">
                            <strong style={{ display: 'block' }}>{this.lbl('vehicle.details.required_fields')}</strong>

                            {(() => {
                              let requiredFields;

                              if (vehicle.vehicle_purpose === 'commercial') {
                                if (vehicle.fuel_type === 'electric' || vehicle.fuel_type === 'elektrisch') {
                                  requiredFields = [
                                    ...env.requiredFieldsCommercial.map(field => field.toLowerCase()),
                                    ...env.requiredFieldsElectric.map(field => field.toLowerCase()),
                                  ];
                                } else {
                                  requiredFields = env.requiredFieldsCommercial.map(field => field.toLowerCase());
                                }
                              } else if (vehicle.vehicle_purpose === 'passenger') {
                                if (vehicle.fuel_type === 'electric' || vehicle.fuel_type === 'elektrisch') {
                                  requiredFields = [
                                    ...env.requiredFieldsPersonal.map(field => field.toLowerCase()),
                                    ...env.requiredFieldsElectric.map(field => field.toLowerCase()),
                                  ];
                                } else {
                                  requiredFields = env.requiredFieldsPersonal.map(field => field.toLowerCase());
                                }
                              }

                              return requiredFields
                                .filter(field => vehicle[field] == null || vehicle[field] === undefined)
                                .map(field => <div key={field}>{this.lbl(`vehicle.property.${field}`)}</div>);
                            })()}
                          </div>

                          <ButtonComponent
                            style={'ButtonSoftEdit'}
                            onClick={() => this.to(`/vehicles/${vehicle.id}/edit/6`)}
                          >
                            {this.lbl('vehicle.details.add_fields')}
                          </ButtonComponent>
                        </div>
                      )}
                    </a>
                  </div>
                  <div className={styles.labelTabel}></div>
                </div>
              </div>
            </>
          )}

          {this.renderAddToOrderButton()}

          {window.innerWidth <= 768 ? (
            this.renderActionModal()
          ) : (
            <>
              {' '}
              {env.clientId !== AppClientId.HILTERMANN && <VehicleOutgoingBPMInvoiceCard vehicle={vehicle} />}
              <div className={styles.containerButtons}>
                {env.clientId !== AppClientId.HILTERMANN && (
                  <div className={styles.productInvoicesCard}>
                    <VehicleGetProductInvoicesCard vehicle={vehicle} />
                  </div>
                )}

                {this.renderProductInvoiceOverviewButton()}
              </div>
            </>
          )}
        </Container>
      </Card>
    );
  }
}

VehicleInfoCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loggedInUserId: selectUserId(),
    changedStatusUser: selectUser(ownProps.vehicle?.user_changed_status),
    work: selectWork(REQUEST_USER),
    workAssignWorkflow: selectWork(REQUEST_WORKFLOW),
    actions: selectActions(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(id, callback) {
      dispatch(fetchUser(id, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleInfoCard = compose(withConnect, withRouter)(VehicleInfoCardComp);
